




























































































































































import Vue from 'vue';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import { formatDateIso } from '../../utils/utils';
import pedidoService from './pedido-service';
import areaService from '../area-atual/area-service';
import routerService from '@/base/router-service';
import produtoService from '../produto/produto-service';
import usuarioService from '../usuario/usuario-service';
import licencaService from '../licenca/licenca-service';
import empresaService from '../empresa/empresa-service';
import empresaAtualService from "../empresa-atual/empresa-atual-service";

interface ISituacaoPagamento {
    id: Api.Common.Domain.SituacaoPagamentoEnum;
    descricao: string;
}

interface IFiltro {
    produto?: number;
    usuario: string;
    situacaoPagamento?: Api.Common.Domain.SituacaoPagamentoEnum;
    empresa: string;
}

@Component
export default class PedidoListar extends Vue {
    itens: Api.App.Server.Pedido.Listar.Dto[] = null;
    produtos: Api.App.Server.Produto.Listar.ProdutoDto[] = [];
    clientes: Api.App.Server.Usuario.ListarClientes.Dto[] = [];
    empresas: Api.App.Server.Empresa.Listar.EmpresaDto[] = [];
    situacoesPagamento: ISituacaoPagamento[] = [];
    areaAtual: string = null;
    paginaAtual: number = 1;
    tamanhoPagina: number = 20;
    quantidadeTotalPaginas: number = null;
    empresaId: string = null;

    filtro: IFiltro = {
        produto: null,
        usuario: null,
        situacaoPagamento: null,
        empresa: null
    };

    formatDateIso = formatDateIso;

    async alterarPagina(incremento: number) {
        this.paginaAtual += incremento;

        if (this.paginaAtual <= 1)
            this.paginaAtual = 1;

        await this.listar();
    }

    get admin() {
        return this.areaAtual == 'admin';
    }

    get carregando() {
        return !this.itens;
    }

    beforeRouteUpdate() {
        this.listar();
    }

    async visualizarPedido(pedidoId: string) {
        await routerService.goTo('pedido-visualizar', {
            pedidoId: pedidoId,
        });
    }

    async estornarPedido(pedidoId: string) {
        await pedidoService.estornar({ pedidoId });
    }

    private async listarProdutos() {
        const { itens } = await produtoService.listar({});
        this.produtos = itens.map((m) => ({
            id: m.id,
            descricao: this.obterNomeProduto(m),
        }));
    }

    obterNomeProduto(item: any) {
        let result = item.titulo;
        if (item.subtitulo) {
            result += ` - ${item.subtitulo}`;
        }

        return result;
    }

    private async listarClientes() {
        const itens = await usuarioService.listarClientes({});
        this.clientes = itens.map((m) => ({
            id: m.id,
            descricao: m.nome,
        }));
    }

    listarSituacoesPagamento() {
        this.situacoesPagamento = [
            {
                id: Api.Common.Domain.SituacaoPagamentoEnum.Sucesso,
                descricao: 'Sucesso',
            },
            {
                id: Api.Common.Domain.SituacaoPagamentoEnum.Falha,
                descricao: 'Falha',
            },
            {
                id: Api.Common.Domain.SituacaoPagamentoEnum.Processando,
                descricao: 'Processando',
            },
            {
                id: Api.Common.Domain.SituacaoPagamentoEnum.NaoIniciado,
                descricao: 'Não Iniciado',
            },
        ];
    }

    async listarEmpresas() {
        let resultado = await empresaService.listar({});
        this.empresas = resultado.itens;
    }

    async carregarDados() {
        this.areaAtual = await areaService.obterAreaPadrao();
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();
        this.listar();
        await this.listar();
        await this.listarProdutos();
        await this.listarClientes();
        this.listarSituacoesPagamento();
        if (!this.empresaId) {
            await this.listarEmpresas();
        }
    }

    created() {
        this.carregarDados();
    }

    private async listar() {
        let empresa = await this.empresaId ? this.empresaId : this.filtro.empresa;
        let resultado = await pedidoService.listar({
            produtoId: this.filtro.produto,
            usuarioId: this.filtro.usuario,
            situacaoPagamento: this.filtro.situacaoPagamento,
            empresaId: empresa,
            paginaAtual: this.paginaAtual,
            tamanhoPagina: this.tamanhoPagina,
        });

        this.quantidadeTotalPaginas = resultado.quantidadeTotalPaginas;

        this.itens = resultado.itens;
    }

    produtoOnChange(value: any) {
        if (value != null) {
            this.filtro.produto = value.id;
        } else {
            this.filtro.produto = null;
        }
    }

    clienteOnChange(value: any) {
        if (value != null) {
            this.filtro.usuario = value.id;
        } else {
            this.filtro.usuario = null;
        }
    }

    situacaoPagamentoOnChange(value: any) {
        if (value != null) {
            this.filtro.situacaoPagamento = value.id;
        } else {
            this.filtro.situacaoPagamento = null;
        }
    }

    empresasOnChange(value: any) {
        if (value != null) {
            this.filtro.empresa = value.id;
        } else {
            this.filtro.empresa = null;
        }
    }
}
